import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import SearchFilterTable from '../../microComponents/tablePages/filter/SearchFilterTable';
import UseSetParams from '../../microComponents/tablePages/filter/UseSetParams';
import SelectFilterTable from '../../microComponents/tablePages/filter/SelectFilterTable';
import DrawerTable from "../productionLine/DrawerTable";
import {getFilterDetailsList} from "../../microComponents/tablePages/getFilterDetailsList";
import {getFilterBranch} from "../../microComponents/tablePages/getFilterBranch";
import DateFilterTable from "../../microComponents/tablePages/filter/DateFilterTable";
import {getFilterProductLine} from "../../microComponents/tablePages/getFilterProductLine";
import GetProductList from "../Products/GetProductList";

const SeriesHistoryColumn = () => {
    const filter = useSelector((state) => state.TableRedux.filter);
    const [getColumnSearchProps] = SearchFilterTable();
    const [filterDetailsList, setFilterDetailsList] = useState({});
    const [filterDetailsListLoading, setFilterDetailsListLoading] = useState(false);
    const [filterBranch, setFilterBranch] = useState([]);
    const [branchLoading, setBranchLoading] = useState(false);
    const [productLineLoading, setProductLineLoading] = useState(false);
    const [filterProductLine, setFilterProductLine] = useState([]);
    const [getColumnDateProps,] = DateFilterTable()

    const [productList, setProductList] = useState([]);
    const [productListLoading, setProductListLoading] = useState(false);
    const [handleSetParams] = UseSetParams();
    const [getColumnSelectProps] = SelectFilterTable();
    // const [productionLines] = useState([]);
    const funcHandleSetParams = (newFilter) => {
        handleSetParams(newFilter);
    };

    const getProductList = () => {
        GetProductList(setProductList, setProductListLoading)
    }

    const getSelectArrData = () => {

        getFilterDetailsList((e) => {
            setFilterDetailsList(e)
        }, setFilterDetailsListLoading)

    }

    const handleGetFilterBranch = () => {

        getFilterBranch(setFilterBranch, setBranchLoading)
    }

    const handleGetFilterProductLine = () => {

        getFilterProductLine(setFilterProductLine, setProductLineLoading)

    }
    const columns = [{
        title: 'ردیف',  className: "hidden lg:table-cell",dataIndex: 'row', key: 'row', render: (text, row, index) => {
            return index + 1;
        },
    },

        {
            title: 'نوع',
            dataIndex: 'seriType',
            key: 'seriType', ...getColumnSelectProps(filter.seriType, 'seriType', ' نوع', filterDetailsList.seriType, getSelectArrData, (res) => {
                funcHandleSetParams([{key: 'seriType', value: res}]);
            }, filterDetailsListLoading),
        },


        // {
            // title: 'واحد',
            // dataIndex: 'branch',
            // key: 'branch', ...getColumnSelectProps(filter.brand, 'branch', 'واحد', filterBranch, handleGetFilterBranch, (res) => {
                // funcHandleSetParams([{key: 'branch', value: res}]);
            // }, branchLoading),
        // },

        // {
            // title: 'خط تولید', className: "hidden 2xs:table-cell",
            // dataIndex: 'productLine',
            // key: 'productLine', ...getColumnSelectProps(filter.brand, 'productLine', 'خط تولید', filterProductLine, handleGetFilterProductLine, (res) => {
                // funcHandleSetParams([{key: 'productLine', value: res}]);
            // }, productLineLoading),


        // },


        {
            title: 'کالا', className: "hidden sm:table-cell",
            dataIndex: 'product',
            key: 'product', ...getColumnSelectProps(filter.product, 'product', 'کالا', productList, getProductList, (res) => {

                funcHandleSetParams([{key: 'product', value: res}]);
            }, productListLoading),
        }, {
            title: '  چاپ شده',className: "hidden sm:table-cell",
            dataIndex: 'printedCounter',
            key: 'printedCounter',
        },

        {
            title: 'تحویل شده', className: "hidden md:table-cell",
            dataIndex: 'registredCounter',
            key: 'registredCounter',
            render: (item, row) => {
                return <div>{row.totalRgisterdCounter > 0 && (`${row.registredCounter} (${row.totalRgisterdCounter}) `)}</div>

            }
        },


        {
            title: 'ابطال ', className: "hidden 2md:table-cell",
            dataIndex: 'cancleCounter',
            key: 'cancleCounter',
        },
        {
            title: 'در حال بررسی', className: "hidden 2md:table-cell",
            dataIndex: 'quarantineCounter',
            key: 'quarantineCounter',
            render: (item, row) => {
                return <div>{row.totalQuarantineCounter > 0 && (`${row.quarantineCounter} (${row.totalQuarantineCounter}) `)}</div>

            }
        },

        {
            title: 'امحا', className: "hidden lg:table-cell",
            dataIndex: 'destroyedCounter',
            key: 'destroyedCounter',
            render: (item, row) => {
                // todo test this line
                return <div>{row.totalDestroyedCounter > 0 && (`${row.destroyedCounter} (${row.totalDestroyedCounter}) `)}</div>
            }
        },
        {
            title: 'بازسازی شده', className: "hidden lg:table-cell",
            dataIndex: 'totalReconstructCounter',
            key: 'totalReconstructCounter',
            render: (item) => {
                return <span>{!!item && item}</span>
            }

        },
        {
            title: 'تعداد کالا', className: "hidden lg:table-cell",
            dataIndex: 'numberPerPallet',
            key: 'numberPerPallet',


        },

        // {
            // title: 'سرپرست تولید ', className: "hidden lg:table-cell",
            // dataIndex: 'createBy',
            // key: 'createBy', ...getColumnSearchProps('سرپرست تولید', filter.createdBy, (res) => {
                // funcHandleSetParams([{key: 'createdBy', value: res}]);
            // },'createdBy'),
        // }, 
		{
            title: 'تاریخ ثبت ', className: "hidden lg:table-cell",
            dataIndex: 'startTime',
            key: 'startTime',...getColumnDateProps([filter.fromStartTime, filter.toStartTime], (res) => {

                funcHandleSetParams([{key: 'fromStartTime', value: res.from_date}, {
                    key: 'toStartTime', value: res.end_date
                }])
            }, 'fromStartTime'),
        },
        // {
            // title: 'زمان پایان ', className: "hidden lg:table-cell",
            // dataIndex: 'endTime',
            // key: 'endTime',
        // },
        {
            title: 'ثبت نشده', fixed: 'right', className: '  cell-fix-left',
            dataIndex: 'home_title',
            key: 'home_title',
            render: (item, row) => {
                let cancleCounter = Number(row.cancleCounter)
                let registredCounter = Number(row.registredCounter)
                let printedCounter = Number(row.printedCounter)
                return <div>{cancleCounter + registredCounter < printedCounter &&
                    //   open drawer by filter id = row.id and palletStatus = 1
                    <DrawerTable
                        filter={{ProductSeri: row.id, palletStatus: 1, page: 1, page_size: 1000}}
                        buttonNumber={printedCounter - (cancleCounter + row.registredCounter)}
                    />
                }</div>
            }
        },

    ];
    return [columns];
};

export default SeriesHistoryColumn;